// const consoleSolutionStaticPath = {
// 	'10052-24A': '/static/leave-management',
// 	'10063-24A': '/static/my-attendance',
// 	'10059-24A': '/static/attendance-management',
// 	'10070-2501': '/static/control-self-assurance',
// 	'10081-2501': '/static/control',
// 	'10085-2501': '/static/budgetary-control',
// 	'10084-2501': '/static/lease-schedule',
// 	'10095-2501': '/static/lease-schedule-v2',
// 	'10097-2501': '/static/lease-schedule-v4',
// 	'10104-2501': '/static/lease-schedule-v5',
// 	'10102-2501': '/static/lease-schedule-v6',
// 	'10148-2501': '/static/lease-schedule-v9',
// 	'10187-2501': '/static/lease-accounting-v10',
// 	'10114-2501': '/static/decommission-asset-accounting',
// 	'10110-2501': '/static/lease-schedule-v7',
// 	'10019-2501': '/static/petty-cash-float-dashboard',
// 	'10020-2501': '/static/petty-cash-reconciliation-dashboard',
// 	'10026-2501': '/static/petty-cash-transaction',
// 	'10027-2501': '/static/petty-cash-transaction-for-cashier',
// 	'10130-2501': '/static/control-self-assurance-v2',
// 	'10134-2501': '/static/kpi-console',
// 	'10145-2501': '/static/team-kpi-evaluation',
// 	'10143-2501': '/static/invoice-ap-console',
// 	'10144-2501': '/static/invoice-treasury-console',
// 	'10163-2501': '/static/lease-payable-v9',
// 	'10186-2501': '/static/lease-payable-approval-v9',
// 	'10164-2501': '/static/fixed-asset-register',
// 	'10168-2501': '/static/tax-payable',
// 	'10194-2501': '/static/salary-management',
// 	'10289-2501': '/static/kpi-comparative-console',
// 	'10293-2501': '/static/acting-position-overview',

// 	'10302-2601': '/static/rate-agreement',
// 	'10300-2601': '/static/project-milestone',
// 	'10301-2601': '/static/rental-subscription',
// 	'10007-24A': '/static/consolidated-contract-administration',
// 	'10306-2601': '/static/lead-kanban',
// 	'10314-2601': '/static/lead-ingestion-pool',
// 	'10315-2601': '/static/lead-screening',
// 	'10316-2601': '/static/lead-assignment',
// 	'10317-2601': '/static/lead-workbench',
// 	'10349-2601': '/static/pre-litigation-kanban',
// 	'10348-2601': '/static/pre-litigation-workbench',
// 	'10321-2601': '/static/lead-back-office-workbench-v2',
// };

// const policySolutionStaticPath = {
// 	'10127-2501': '/static/leave-combine',
// };

// const identitySolutionStaticPath = {
// 	'10068-2501': '/static/committee',
// 	'10147-2501': '/static/lease-record-management-v9',
// 	'10101-2501': '/static/lease-record-management-v6',
// 	'10309-2601': '/static/raw-lead-records',
// 	'10113-2501': '/static/decommission-asset',
// 	// '10126-2501': '/static/key-performance-indicator',
// 	// '10133-2501': '/static/kpi-evaluation',
// };

// const taskSolutionStaticPath = {};

// const allStaticSolutionPath = {
// 	...identitySolutionStaticPath,
// 	...policySolutionStaticPath,
// 	...taskSolutionStaticPath,
// };

const getLocalSolutionURLByVertical = () => {
	try {
		const raw = localStorage.getItem('solutionURLByVertical');
		if (!raw) return {};
		const parsed = JSON.parse(raw);
		return parsed && typeof parsed === 'object' ? parsed : {};
	} catch (error) {
		return {};
	}
};

const getCompanyCode = () => {
	try {
		return localStorage.getItem('companyCode') || '';
	} catch (error) {
		return '';
	}
};

// Flat lookup: solutionURLByVertical[companyCode-processCode-processVersion]
export const solutionURLByVertical = {};

const localSolutionURLByVertical = getLocalSolutionURLByVertical();
Object.assign(solutionURLByVertical, localSolutionURLByVertical);
